module.exports = __webpack_public_path__ + "static/media/explore_image.5f05cc22.svg";